import CornerGripperLogo from '../components/CornerGripperLogo';
import PinCodeEntry from '../components/PinCodeEntry';

import './PinCodeEntryScreen.scss';

export interface PinCodeEntryScreenProps {
  clickForgot: () => void;
  code: Map<number, number | null>;
  givenTo: string;
  setCode: (code: Map<number, number | null>) => void;
  tapToReload: () => void;
  inputError: string;
  setInputError: (error: string) => void;
  pickupLocation?: string;
  clickNext: () => void;
  tasksToUnload: string[];
}

export default function PinCodeEntryScreen({
  clickForgot,
  code,
  givenTo,
  setCode,
  tapToReload,
  inputError,
  setInputError,
  pickupLocation,
  clickNext,
  tasksToUnload,
}: PinCodeEntryScreenProps) {
  return (
    <div className="pin-code-entry-screen">
      <CornerGripperLogo tapToReload={tapToReload} />
      <div className="pin-code-entry-screen__content">
        <h1 className="content__title-text">
          Enter your multi-factor delivery code{pickupLocation ? ` from ` : ''}
          {pickupLocation && <span className="content__title-text--highlighted">{pickupLocation}</span>}
        </h1>
        <h3 className="content__subtitle-text">{givenTo}</h3>
        <div className={`content__input-wrapper`}>
          <div className="content__input-container">
            <PinCodeEntry code={code} setCode={setCode} isInvalid={!!inputError} setInputError={setInputError} />
            <div role="alert" className="content__input-error">
              {!!inputError ? inputError : ''}
            </div>
            <button className="content__forgot-button" onClick={clickForgot}>
              I forgot the code
            </button>
            {pickupLocation && tasksToUnload.length > 1 && (
              <button className="content__forgot-button" onClick={clickNext}>
                Skip to the next location's code
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
